import React from 'react';
import ColumnChart from './ColumnChart';

export default function ColumnChartWidget({ data }) {
  return (
    <div
      className="report-widget report-kpi-card"
      style={{ width: 500 }}
    >
      <div className="report-widget__header">
        <div className="report-widget__inner">
          <h3 className="report-widget__title">Acesso por série</h3>
        </div>
      </div>

      <div className="report-widget__body">
        <ColumnChart data={data} />
      </div>
    </div>
  );
}
